import CommonAction from "./CommonAction";
import BaseReducer from "../../utilities/BaseReducer";
import environment from "environment";


export default class CommonReducer extends BaseReducer {
  initialState = {
    currentView: this.getInitialView(),
    currentLanguage: this.getInitialLanguage(),
    selectedDocument: null,
    currentPosition: null,
    options: {
      sortBy: this.getInitialSortBy(),
      sortOrder: this.getInitialSortOrder(),
      pageNumber: "1",
      pageSize: "10",
      search: null,
      updation_status: null,
      extraction_status:[]
    },
  };

  getInitialView() {
    const env = environment.APP_ENVIRONMENT; 
    return (env === "alabusTesting" || env === "eponaDevelopment" || env === "eponaTesting" || env === "eponaProduction") ? "Grid" : "List";
  }

  getInitialLanguage() {
    const env = environment.APP_ENVIRONMENT;
    return (env === "alabusTesting" || env === "eponaDevelopment" || env === "eponaTesting" || env === "eponaProduction") ? "English" : "German";
  }

  getInitialSortBy() {
    const env = environment.APP_ENVIRONMENT;
    return (env === "alabusTesting" || env === "eponaDevelopment" || env === "eponaTesting" || env === "eponaProduction") ? "file_name" : "received_at";
  }

  getInitialSortOrder() {
    const env = environment.APP_ENVIRONMENT;
    return (env === "alabusTesting" || env === "eponaDevelopment" || env === "eponaTesting" || env === "eponaProduction") ? "ASC" : "DESC";
  }

  [CommonAction.SET_CURRENT_VIEW](state, action) {
    return {
      ...state,
      currentView: action.payload,
    };
  }
  [CommonAction.SET_CURRENT_LANGUAGE](state, action) {
    return {
      ...state,
      currentLanguage: action.payload,
    };
  }

  [CommonAction.SET_PAGE_OPTIONS](state, action) {
    return {
      ...state,
      options: action.payload
    };
  }
  
  [CommonAction.SET_SELECTED_DOCUMENT](state, action) {
    return {
      ...state,
      selectedDocument: action.payload
    };
  }

  [CommonAction.SET_CURRENT_POSITION](state, action) {
    return {
      ...state,
      currentPosition: action.payload
    };
  }
}
